import { BulkBatchRecord } from '../types/bulk-mis';

/**
 * Format a duration in seconds to a human-readable string (e.g., "5s", "2m 30s", "1h 15m").
 */
export const formatSeconds = (totalSecs: number): string => {
  const diffMins = Math.floor(totalSecs / 60);
  const diffSecs = Math.floor(totalSecs % 60);
  if (diffMins > 60) {
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `${hours}h ${mins}m`;
  } else if (diffMins > 0) {
    return `${diffMins}m ${diffSecs}s`;
  } else {
    return `${diffSecs}s`;
  }
};

/**
 * Get the processing time for a batch record, preferring the pre-computed
 * `processing_time_secs` field and falling back to created_at/updated_at diff.
 */
export const getProcessingTime = (batch: BulkBatchRecord): string => {
  if (batch.processing_time_secs != null) {
    return formatSeconds(batch.processing_time_secs);
  }
  const created = new Date(batch.created_at);
  const updated = new Date(batch.updated_at);
  const diffSecs = (updated.getTime() - created.getTime()) / 1000;
  return formatSeconds(diffSecs);
};
